export const messages = {
  en: {
    productGroupOrderReturn: {
      queryCondition: 'Query Condition',
      returnIdPlaceholder: 'Please enter return ID',
      orderIdPlaceholder: 'Please enter order ID',
      returnTypePlaceholder: 'Please select refund type',
      query: 'Query',
      title: 'Group Order Refund',
      returnId: 'Return ID',
      orderId: 'Order',
      product: 'Product',
      buyer: 'Buyer',
      quantity: 'Quantity',
      groupPrice: 'Group Price',
      refundAmount: 'Refund Amount',
      refundType: 'Refund Type',
      refundReason: 'Refund Reason',
      status: 'Status',
      auditNote: 'Audit Note'
    }
  },
  zh: {
    productGroupOrderReturn: {
      queryCondition: '查询条件',
      returnIdPlaceholder: '请输入退单ID',
      orderIdPlaceholder: '请输入订单ID',
      returnTypePlaceholder: '请选择退款类型',
      query: '查询',
      title: '拼团退单',
      returnId: '退单编号',
      orderId: '订单',
      product: '商品',
      buyer: '购买人',
      quantity: '购买数量',
      groupPrice: '拼团价格',
      refundAmount: '退款金额',
      refundType: '退款类型',
      refundReason: '退款原因',
      status: '状态',
      auditNote: '审核说明'
    }
  }
}